import { ChatEventType } from '../enums';
export class UserTypingEvent {
    constructor({ userId, conversationId, content, isTyping }) {
        this.type = ChatEventType.UserTyping;
        this.userId = void 0;
        this.conversationId = void 0;
        this.content = void 0;
        this.isTyping = void 0;
        this.userId = userId;
        this.conversationId = conversationId;
        this.content = content;
        this.isTyping = isTyping;
    }
}
